export const addTagsIfMissing = (initialTags: string[] | undefined, toBeAdded: string[]) => {
  const tags = [...(initialTags ?? [])];

  toBeAdded.forEach((addedTag) => {
    if (!tags.includes(addedTag)) tags.push(addedTag);
  });

  return tags;
};
